import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NavigationHistoryState {
  history: string[];
}

const initialState: NavigationHistoryState = {
  history: [],
};

const navigationHistorySlice = createSlice({
  name: 'navigationHistory',
  initialState,
  reducers: {
    pushToHistory: (state, action: PayloadAction<string>) => {
      // Don't add the route if it's the same as the latest one
      const latestRoute = state.history[state.history.length - 1];
      if (latestRoute !== action.payload) {
        state.history.push(action.payload);
        if (state.history.length > 10) {
          state.history.shift();
        }
      }
    },
    clearHistory: (state) => {
      state.history = [];
    },
  },
});

export const { pushToHistory, clearHistory } = navigationHistorySlice.actions;
export default navigationHistorySlice.reducer;
